<template>
<div class="relative my-20">
  <div class="flex">
      <router-link  v-if="previous != ''" class="btn-primary"  :to="`${previous}`" @click="InlineButtonClickHandler(current)">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </router-link>
      <div class="flex-grow"></div>

      <router-link  v-if="next != ''" class="btn-primary" :to="`${next}`"  @click="InlineButtonClickHandler(current)">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 5l7 7-7 7"
          />
        </svg>
      </router-link>
    </div>
</div>

</template>

<script>
export default {
  name: "BtnGroupBottom",
  methods: {
    InlineButtonClickHandler(current) {
      this.$emit("InlineButtonClickHandler", current);
    },
  },
  props: ['previous', 'next', 'current'],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
